const initState = {
	badges: [],
	singleBadge: null,
    isLoading: false
};

const myEndorseReducer = (state = initState, action) => {
	switch (action.type) {
		case 'GET_ENDORSE_BADGE':
			return {
				...state,
				badges: action.payload,
			};
			case 'GET_SINGLE_ENDORSE_BADGE':
				return {
					...state,
					singleBadge: action.payload,
				};
			case 'CLEAR_SINGLE_ENDORSE_BADGE':
				return {
					...state,
					singleBadge: null,
				};
            case "SET_IS_LOADING":
                return {
                  ...state,
                  isLoading: action.payload,
                };
		default:
			return {
				...state,
			};
	}
};
export default myEndorseReducer;
